// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yO3N","content":"styles_content__3tSit","tableWrap":"styles_tableWrap__3a702"};